import React from "react";
import { Link } from "react-router-dom";
import { homePageV2Collective } from "../content/homePageV2Content";

export function CollectiveSectionV2() {
  const { headline, body, cta, quote, founder, link } = homePageV2Collective;

  return (
    <section className="mh2v2-collective mh2v2-section-light" id="membership">
      <div className="mh2v2-container">
        <h3 className="mh2v2-section-title mh2v2-section-title--center">
          THE MAMAHOOD COLLECTIVE
        </h3>

        <div className="mh2v2-collective-grid">
          <div className="mh2v2-collective-info">
            <h4>{headline}</h4>
            <div className="mh2v2-round-logo mh2v2-round-logo--xl">TMC</div>
            <p>{body}</p>
            <Link to={cta.to} className="mh2v2-pill mh2v2-pill--gold">
              {cta.label} →
            </Link>

            <blockquote className="mh2v2-quote-chip">
              &quot;{quote.text}&quot;
              <span>{quote.attribution}</span>
            </blockquote>
          </div>

          <div className="mh2v2-founder-panel">
            <h4 className="mh2v2-section-title mh2v2-section-title--center">
              FEATURED FOUNDERS:
            </h4>
            {/* TODO: rotating featured founders */}
            <Link to={founder.to}>
              <img src={founder.image} alt={founder.name} />
            </Link>
            <div className="mh2v2-founder-panel__body">
              <div>
                <span className="mh2v2-founder-brand">{founder.brand}</span>
              </div>
              <div>
                <h5>{founder.name}</h5>
                <p>{founder.bio}</p>
                <p>{founder.note}</p>
              </div>
            </div>
          </div>
        </div>

        <Link className="mh2v2-link-row" to={link.to}>
          {link.label} →
        </Link>
      </div>
    </section>
  );
}

export default CollectiveSectionV2;
